import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { TextField, Button, CardMedia, Input } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ChangeEvent, useEffect, useState } from "react";
import { UploadMedia } from "../../utils/mediaUpload";
import useAuth from "../../hooks/useAuth";
import { usePostSetProfileMutation } from "../../service/auth";
import { showToast } from "../../constants/toasts";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { isValidInput } from "../../utils/validations";

const EditProfile = () => {
  const user = useAuth();
  const navigate = useNavigate();
  const [updateProfile] = usePostSetProfileMutation();

  const [fileName, setFileName] = useState<string>("");
  const [submitted, setSubmitted] = useState(false);
  const [profileImage, setProfileImage] = useState("");
  const [fullName, setFullName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [phone, setPhone] = useState(user?.phoneNo || "");
  const [dialCode, setDialCode] = useState(user?.dialCode || "");

  const handleChangePhone = (phone: any, country: any) => {
    setPhone(phone?.replace(country.dialCode, ""));
    setDialCode(country?.dialCode);
  };

  const handleProfileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setProfileImage("");
      return;
    }

    const imageUrl = (await UploadMedia(file, user?.id)) as any;
    if (imageUrl?.data) {
      setProfileImage(imageUrl?.data || "");
    }
  };

  const onSubmit = async () => {
    setSubmitted(true);

    if (!fullName?.length) {
      return;
    }
    if (!phone?.length) {
      return;
    }

    const body = {
      userId: user?.id,
      name: fullName,
      email: email,
      phoneNumber: phone,
      countryCode: dialCode,
    };
    try {
      // const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await updateProfile(body).unwrap();
      if (response?.status === 200) {
        showToast("Profile updated successfully");
        navigate("/manage-profile");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (user) {
      setFullName(user?.name || "");
      setEmail(user?.email || "");
      setPhone(user?.phoneNumber?.phone || "");
      setProfileImage(user?.profileImage || "");
      setDialCode(user?.phoneNumber?.countryCode || "");
    }
  }, [user]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Edit Profile</h1>
        <p>
          <span
            role="button"
            tabIndex={0}
            onClick={() => navigate("/dashboard")}
          >
            Dashboard
          </span>{" "}
          -{" "}
          <span
            role="button"
            tabIndex={0}
            onClick={() => navigate("/manage-profile")}
          >
            Manage Profile
          </span>{" "}
          - Edit Profile
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group w_100">
              <label>Upload Image</label>
              {profileImage ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia
                        component="img"
                        image={profileImage}
                        alt="photo"
                      />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setProfileImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label className="upload_image" htmlFor="icon-button-file">
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg",
                    }}
                    onChange={(e: any) => {
                      handleProfileUpload(e);
                      e.target.value = null;
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="icon"
                      />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="icon" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>
            <div className="control_group w_33">
              <label htmlFor="Name">Name</label>
              <TextField
                placeholder="Enter Name"
                id="Name"
                hiddenLabel
                fullWidth
                value={fullName}
                onChange={(val) => {
                  if (isValidInput(val.target.value)) {
                    setFullName(val.target.value);
                  }
                }}
              />
            </div>
            <div className="control_group w_33">
              <label htmlFor="Email">Email Id</label>
              <TextField
                placeholder="Enter Email Id"
                id="Email"
                hiddenLabel
                fullWidth
                disabled
                value={email}
                onChange={(val) => {
                  if (isValidInput(val.target.value)) {
                    setEmail(val.target.value);
                  }
                }}
              />
            </div>
            <div className="control_group w_33">
              <label>Phone Number</label>
              <PhoneInput
                enableSearch
                value={dialCode + phone}
                country={"uae"}
                inputClass="phoneInput"
                onChange={(phone, country) => handleChangePhone(phone, country)}
                inputStyle={{ width: "100%", backgroundColor: "#232323" }}
                buttonClass="phoneBtn"
                placeholder="Phone Number"
              />
              <p className="err_msg">
                {submitted && !phone?.length ? "Phone number is required" : ""}
              </p>
            </div>
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary" onClick={onSubmit}>
              Next
            </Button>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default EditProfile;
